import { baseMetrics } from './constants';
import { ADVANCED_METRICS_APP } from '../../../utils/advanced-metrics';

export const retentionMetrics = {
  churn: ADVANCED_METRICS_APP.churn,
  retention: baseMetrics.retention,
};

export const engagementMetrics = {
  average_time_spent_per_dau: ADVANCED_METRICS_APP.average_time_spent_per_dau,
  average_sessions_per_dau: ADVANCED_METRICS_APP.average_sessions_per_dau,
};

export const advancedMetrics = {
  average_time_spent_per_dau: ADVANCED_METRICS_APP.average_time_spent_per_dau,
  average_sessions_per_dau: ADVANCED_METRICS_APP.average_sessions_per_dau,
  churn: ADVANCED_METRICS_APP.churn,
  sessions_penetration: ADVANCED_METRICS_APP.sessions_penetration,
  time_spent_penetration: ADVANCED_METRICS_APP.time_spent_penetration,
  time_spent_segment_penetration: ADVANCED_METRICS_APP.time_spent_segment_penetration,
  mau_penetration: ADVANCED_METRICS_APP.mau_penetration,
  wau_penetration: ADVANCED_METRICS_APP.wau_penetration,
};

export const activityMetrics = {
  mau: 'MAU', // baseMetrics.mau
  dau: 'DAU', // baseMetrics.dau
  sessions: 'Sessions', // baseMetrics.sessions
  total_time_spent: 'Time Spent', // baseMetrics.total_time_spent
};

export const unitsByMetric = {
  retention: '%',
  churn: '%',
  wau_penetration: '%',
  mau_penetration: '%',
  sessions_penetration: '%',
  time_spent_penetration: '%',
  time_spent_segment_penetration: '%',
  average_time_spent_per_dau: ' minutes',
  average_sessions_per_dau: '',
};
